<template>
  <Card :showBtn="false" :btnMsg="$t('thanksAll.btn_text')">
    <div class="card-thanksAll">
      <div class="bg"></div>
      <div class="card-content">
        <div class="card-title" v-html="$t('thanksAll.title')"></div>
        <!-- <div>
          <div class="card-title-desc" v-html="$t('thanksAll.title_desc1')"></div>
          <div class="card-title-desc" v-html="$t('thanksAll.title_desc2')"></div>
        </div> -->
        <div class="card-text" v-html="$t('thanksAll.text')"></div>
      </div>
      <van-icon name="cross" @click="cancel" />
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    cancel() {
      this.$emit('input', {});
      this.$parent.changeStep('formBasic');
    },
  },
};
</script>

<style lang="scss">
.card-thanksAll {
  position: relative;
  width: 100%;
  min-height: 300px;
  .bg {
    width: 160px;
    height: 160px;
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right;
    background-image: url('../../assets/thanks-bg1.png');
  }
  .card-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card-title {
    font-family: 'Taviraj', sans-serif;
    // font-family: 'Pattaya', sans-serif;
    font-size: 34px;
    font-weight: 700;
    padding-top: 40px;
    margin-bottom: 20px;
    text-align: center;
    line-height: 50px;
    // -webkit-text-fill-color: transparent;
    // background: linear-gradient(to bottom, #dfcb96, #dc9774);
    // -webkit-background-clip: text;
    color: #dc9774cc;
  }
  .card-title-desc {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    -webkit-text-fill-color: transparent;
    background: linear-gradient(to bottom, #ffc977, #ff330f);
    -webkit-background-clip: text;
  }
  .card-text {
    font-size: 17px;
    line-height: 24px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .van-icon {
    position: absolute;
    top: -8px;
    right: -8px;
    border: 1px solid;
    padding: 2px;
    border-radius: 50%;
  }
}
</style>
